import { Component, DestroyRef, ChangeDetectionStrategy } from '@angular/core';
import { AuthService } from '../../services/auth.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { RegisterValidators } from '../../validators/register-validators';
import { IRegisterData } from '../../models/credentials.model';
import { ActivatedRoute, Router } from '@angular/router';
import { ErrorMessageUtils } from '../../utils/ErrorMessageUtils';
import { AlertSeverity } from '../../ui/alert.component';

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class RegisterComponent {
  firstName = new FormControl('', [
    Validators.required,
    Validators.minLength(2),
  ]);

  lastName = new FormControl('', [
    Validators.required,
    Validators.minLength(2),
  ]);
  // No async email-taken validator: it leaks which addresses are registered and
  // silently no-ops once Firebase's email-enumeration protection is on. A duplicate
  // address surfaces from the auth/email-already-in-use error on submit instead.
  email = new FormControl('', [Validators.required, Validators.email]);
  password = new FormControl('', [
    Validators.required,
    Validators.minLength(8),
  ]);
  confirm_password = new FormControl('', [
    Validators.required,
    Validators.minLength(8),
  ]);
  chipnumber = new FormControl('', {
    validators: [Validators.required],
  });

  readPrivacyStatement = new FormControl('', [Validators.requiredTrue]);
  registerForm: FormGroup = new FormGroup(
    {
      firstName: this.firstName,
      lastName: this.lastName,
      email: this.email,
      password: this.password,
      confirm_password: this.confirm_password,
      readPrivacyStatement: this.readPrivacyStatement,
      chipnumber: this.chipnumber,
    },
    [RegisterValidators.match('password', 'confirm_password')],
  );

  inSubmission: boolean = false;
  showAlert: boolean = false;
  severity: AlertSeverity = 'info';
  message: string = '';
  // Driven by the /proefles route data: hides the chipnumber field and registers a
  // trial account that may book exactly one class.
  isTrial: boolean = false;

  constructor(
    private destroyRef: DestroyRef,
    private authService: AuthService,
    private router: Router,
    private route: ActivatedRoute,
  ) {
    this.isTrial = this.route.snapshot.data['trial'] === true;
    if (this.isTrial) {
      this.chipnumber.clearValidators();
      this.chipnumber.updateValueAndValidity();
    }
  }

  async registerUser() {
    if (this.registerForm.value.readPrivacyStatement === true) {
      this.inSubmission = true;
      try {
        await this.authService.registerUser({
          ...this.registerForm.value,
          trial: this.isTrial,
        } as IRegisterData);
        this.inSubmission = false;
        this.showAlert = true;
        this.severity = 'success';
        this.message = 'Registratie succes!';
        localStorage.setItem('emailForSignIn', this.registerForm.value.email);
        setTimeout(() => {
          this.router.navigate([
            '/login',
            { showEmailNotYetVerifiedMessage: true },
          ]);
        }, 500);
      } catch (error: any) {
        this.inSubmission = false;
        this.showAlert = true;
        this.severity = 'error';
        this.message =
          ErrorMessageUtils.determineFrontendMessageBasedOnError(error);
        this.registerForm.reset();
      }
    }
  }

  navigateToLogin(): void {
    this.router.navigate(['/login']);
  }
}
